<template>
  <span v-if="buttonList.length>0">
    <!-- btn列表 -->
      <!-- 这里触发点击事件 -->
      <el-button
        v-for="item in buttonList"
        :key="item.Name"
        :value="item.Id"
        type="primary"
        @click="callFunc(item)"
        size="small"
        :icon="item.Icon"
        round
      >{{item.Name}}</el-button>
  </span>
</template>
<script>
export default {
  name: "Toolbar",
  data () {
    return {
      searchVal: "", //双向绑定搜索内容
      showVal: true,
      searchmsg: null,
    };
  },
  props: ["buttonList"], //接受父组件传值
  methods: {
    callFunc (item) {
      item.search = this.searchVal;
      this.$emit("callFunction", item); //将值传给父组件
    }
  },
  mounted () {

  }
};
</script>